export default "__VITE_ASSET__08cfb318__"